import { useSearchParams } from "react-router-dom"
import Header from "../../../../../Components/Header/Header"
import Sidebar from "../../../../../Components/Sidebar/Sidebar"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Get_A_Report_Execution_SelectDataAPI, Post_A_Report_Execution_InsertDataAPI, Post_A_Report_Execution_InsertDataAPI1 } from "../../../../../Redux/ReportExecutionSlice/ReportExecutionSlice"
import { useAuthState } from "../../../../../Helper/Context"
import { Loading } from "../../../../../Helper/Loading"
import { toastErrorr, toastInfo } from "../../../../../Helper/ToastMessage"
import { AstricSign } from "../../../../../Helper/AstricSign"
import moment from "moment"
import { MonthDataDDL } from "../../../../../Components/CommonDDL/MonthDataDDL"
import ExecutionDateModal from "./Modal/ExecutionDateModal"
import { FinancialYearDataDDL } from "../../../../../Components/CommonDDL/FinancialYearDataDDL"

export const ReportExecution = () => {

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails.user

    const [searchParams] = useSearchParams()
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    const [ReportFromDate, setReportFromDate] = useState('')
    const [ReportToDate, setReportToDate] = useState('')
    const [loading, setloading] = useState('')
    const [ExecutionDateViewPopUp, setExecutionDateViewPopUp] = useState(false)
    const [GridData, setGridData] = useState(false)


    const handleView = (data) => {
        setExecutionDateViewPopUp(true)
        setGridData(data)
    }
    const handleViewClose = (data) => {
        setExecutionDateViewPopUp(false)
        setGridData('')
    }


    const [Month, setMonth] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [FinancialYear, setFinancialYear] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleClear = () => {
        setReportFromDate('')
        setReportToDate('')
    }

    useEffect(() => {
        handleGetData()
    }, [])

    const handleGetData = () => {
        const data = {
            UserID: UserID,
            token: token
        }
        dispatch(Get_A_Report_Execution_SelectDataAPI({ data }))
    }

    const { isLoading, TableData } = useSelector(state => state.Get_A_Report_Execution_SelectData)

    // const handleCallRunPost = (i) => {
    //     // let currentDate = new Date(ReportFromDate);
    //     // while (currentDate <= new Date(ReportToDate)) {
    //     //     handleRunPost(i, moment(currentDate).format('YYYY-MM-DD'))
    //     //     currentDate.setDate(currentDate.getDate() + 1)
    //     // }
    //     handleRunPost(i, ReportFromDate)
    // }


    const handleCallRunPost = async (i) => {
        if (!ReportFromDate || !ReportToDate) {
            toastInfo("Please Select Dates");
            return;
        }

        let currentDate = moment(ReportFromDate, "YYYY-MM-DD");
        const endDate = moment(ReportToDate, "YYYY-MM-DD");

        while (currentDate <= endDate) {
            const reportDate = currentDate.format("YYYY-MM-DD");

            const success = await handleRunPost(i, reportDate);

            if (!success) {
                break;
            }

            currentDate.add(1, "day");
        }
    };

    const handleRunPost = async (i, reportdate) => {
        const APIFlag =
            i?.name_SP === "DB_SUBMAIN_WS_INSERT"
                ? "WaterSupply"
                : i?.name_SP === "DB_SUBMAIN_SW_INSERT"
                    ? "Sewerage"
                    : i?.name_SP === "DB_SUBMAIN_STP_INSERT"
                        ? "STP"
                        : i?.name_SP === "DB_SUBMAIN_WTP_INSERT"
                            ? "WTP"
                            : i?.name_SP === "DB_SUBMAIN_GARDEN_INSERT"
                                ? "Garden"
                                : null;

        if (!APIFlag) {
            toastErrorr("API Flag Parameter Condition Mismatch");
            return false;
        }
        if (!ReportFromDate) {
            toastInfo("Please Select Dates");
            return;
        } else {
            const data = {
                setloading,
                // CurrentDate: reportdate,
                CurrentDate: ReportFromDate,
                M_UserID: UserID,
                token,
                Flag: APIFlag,
                handleIsPost,
            };

            try {
                const response = await dispatch(Post_A_Report_Execution_InsertDataAPI1({ data })).unwrap();

                if (response?.status === true) {
                    return true;
                } else {
                    return false;
                }
            } catch (error) {
                console.error("API error:", error);
                return false;
            }
        }
    };


    const handleIsPost = (res) => {
        if (res == ReportToDate) {
            setloading(false)
        }
        else if (res == "Error") {
            setloading(false)
        }
    }

    const handleSearch = () => {

    }

    return (
        <>
            {isLoading && <Loading />}
            {loading && <Loading />}
            <div>
                <Header />
                <div className="wrapper">
                    <Sidebar
                        ProjectTypeId={ProjectTypeId}
                        active='ReportExecution'
                    />
                    <div className="content">
                        <div className="data_mob">
                            <div className="row  m-1 py-1 pb-4 master_border">
                                <div>
                                    <h5 className="ps-1 py-1 ">Report Execution </h5>

                                </div>
                                <div className="row m-0 ">
                                    <div className="col-12 py-1  rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: " #27466317" }}>
                                        <div className="col-12  ">

                                            <div className="row py-1 rounded2">

                                                {/* <div className="col-1 pt-1 pl-4">
                                                    <label for=""><b>Date</b><AstricSign /> : </label>
                                                </div> */}

                                                <div className="col-12 col-md-4 col-lg-2">
                                                    <FinancialYearDataDDL
                                                        FinancialYear={FinancialYear}
                                                        setFinancialYear={setFinancialYear}
                                                        Flag='PenealtyReport'
                                                        isCompulsory={true}
                                                    />
                                                </div>

                                                <div className="col-12 col-md-4 col-lg-2">
                                                    <MonthDataDDL
                                                        Month={Month}
                                                        setMonth={setMonth}
                                                        isCompulsory={true}
                                                    />
                                                </div>


                                                <div className="col-3 col-lg-3">
                                                    <label for=""><b>Select Date</b><AstricSign /></label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        id="exampleInputEmail1" name='EmployeeName'
                                                        aria-describedby="emailHelp"
                                                        value={ReportFromDate}
                                                        max={moment().format('YYYY-MM-DD')}
                                                        onChange={(e) => setReportFromDate(e.target.value)}
                                                    />
                                                </div>

                                                {/* <div className="col-3 col-lg-3">
                                                    <label for=""><b>To Date</b><AstricSign /></label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        id="exampleInputEmail1" name='EmployeeName'
                                                        aria-describedby="emailHelp"
                                                        value={ReportToDate}
                                                        max={moment().format('YYYY-MM-DD')}
                                                        min={moment(ReportFromDate).format('YYYY-MM-DD')}
                                                        onChange={(e) => setReportToDate(e.target.value)}
                                                    />
                                                </div> */}



                                                <div className="col-12 col-md-3 col-lg-2 d-md-flex mt-4" >
                                                    {/* <button type="button"
                                                        className="btn-clear btn btn-primary mx-2"
                                                        onClick={handleSearch}
                                                    >
                                                        Search</button> */}
                                                    <button type="button"
                                                        className="btn btn-outline-danger"
                                                        onClick={handleClear}
                                                    >
                                                        Clear</button>
                                                </div>

                                            </div>

                                            <div className="row mob_table table-responsive pt-1">

                                                <table id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            <th>Project Type</th>
                                                            <th>Procedure name</th>
                                                            <th>Execution Date</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            TableData && TableData.length > 0 ? TableData.map((i, j) => {
                                                                return (
                                                                    <tr style={{ width: '100%' }}>
                                                                        <td style={{ textAlign: "center" }}>{j + 1}</td>
                                                                        <td>{i?.details_SP}</td>
                                                                        <td>{i?.name_SP}</td>
                                                                        <td style={{ width: '10%', textAlign: "center" }}>
                                                                            <span className="btn btn-secondary float-center"
                                                                                onClick={() => handleView(i)}
                                                                                style={{ color: "white" }}>
                                                                                <text className="poppins" style={{ fontStyle: 'normal' }}>Date View</text>
                                                                            </span>
                                                                        </td>

                                                                        <td style={{ width: '10%', textAlign: "center" }}>
                                                                            <i className="btn btn-secondary float-center"
                                                                                // onClick={() => handleCallRunPost(i)}
                                                                                onClick={() => handleRunPost(i)}
                                                                                style={{ color: "white" }}>
                                                                                <text className="poppins" style={{ fontStyle: 'normal' }}>RUN</text>
                                                                            </i>
                                                                        </td>

                                                                    </tr>
                                                                )
                                                            })
                                                                :
                                                                <tr><td colSpan={4}>No Data Found</td></tr>
                                                        }



                                                    </tbody>
                                                </table>

                                            </div>
                                            {/* {tableData && tableData.table && tableData.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            } */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                {
                    ExecutionDateViewPopUp ?
                        <ExecutionDateModal
                            open={ExecutionDateViewPopUp}
                            GridData={GridData}
                            handleViewClose={handleViewClose}
                            Month={Month}
                            FinancialYear={FinancialYear}
                        />
                        : <></>
                }
            </div>
        </>
    )
}